"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeFetchableStatic = exports.IkeCollectionLoaderFromState = void 0;
const __1 = require("..");
class IkeCollectionLoaderFromState {
    constructor(collections, forms, captures, calibrations) {
        this.Collection = {
            getByRevision: (revision) => this.getBy(this.collections, 'revision', revision),
            getModel: (revision) => this.getOrCreate(this.collectionModel, 'revision', revision, () => {
                const collectionJson = this.Collection.getByRevision(revision).value;
                const form = this.Form.getModel(collectionJson.formversion).value;
                const collection = __1.IkeModel.Collection.read(collectionJson, form, this);
                return collection;
            }),
        };
        this.CollectionSummary = {
            getById: (objectId) => this.getSummary('objectId', objectId),
            getByUuid: (uuid) => this.getSummary('uuid', uuid),
        };
        this.Form = {
            getById: (id) => this.getBy(this.forms, 'objectId', id),
            getByRevision: (revision) => this.getBy(this.forms, 'version', revision),
            getModel: (revision) => this.getOrCreate(this.formModel, 'version', revision, () => __1.IkeModel.Form.read(this.Form.getByRevision(revision).value)),
        };
        this.Capture = {
            getById: (objectId) => this.getBy(this.captures, 'objectId', objectId),
            getByUuid: (uuid) => this.getBy(this.captures, 'uuid', uuid),
        };
        this.Calibration = {
            getById: (objectId) => this.getBy(this.calibrations, 'objectId', objectId),
        };
        /** Will fetching objects throw errors if they cannot be found */
        this.isMissingAllowed = false;
        this.setCollections(collections);
        this.setForms(forms);
        this.setCaptureCalibration(captures, calibrations);
    }
    fromState(state) {
        this.setCollections(state.Collection);
        this.setForms(state.Form);
        this.setCaptureCalibration(state.Capture, state.Calibration);
    }
    setCollections(collections = []) {
        this.collections = collections.slice();
        this.collectionModel = [];
    }
    setForms(forms = []) {
        this.forms = forms.slice();
        this.formModel = [];
    }
    addForm(form) {
        this.addUnique(this.forms, form, 'version');
    }
    addCollection(collection) {
        this.addUnique(this.collections, collection, 'revision');
    }
    setCaptureCalibration(captures = [], calibrations = []) {
        this.captures = captures.slice();
        this.calibrations = calibrations.slice();
    }
    addCaptureCalibration(capture, calibration) {
        this.addUnique(this.captures, capture, 'uuid');
        if (calibration != null) {
            this.addUnique(this.calibrations, calibration, 'objectId');
        }
    }
    setIsMissingAllowed(isMissingAllowed) {
        this.isMissingAllowed = isMissingAllowed;
    }
    /** Add a item to the array only if it doesn't exist already */
    addUnique(objects, obj, key) {
        const value = obj[key];
        if (objects.find((f) => f[key] === value)) {
            return;
        }
        objects.push(obj);
    }
    getBy(objects, key, value) {
        const foundItem = objects.find((t) => t[key] === value);
        // IkeRest will return null, so should this
        if (foundItem == null && this.isMissingAllowed !== true) {
            throw new Error(`Unable to fetch ${key}:${value}`);
        }
        return new IkeFetchableStatic(foundItem);
    }
    getOrCreate(objects, key, value, create) {
        try {
            return this.getBy(objects, key, value);
        }
        catch (_e) {
            objects.push(create());
            return this.getBy(objects, key, value);
        }
    }
    getSummary(key, value) {
        const collection = this.getBy(this.collections, key, value).value;
        if (collection == null) {
            throw new Error(`Unable to find collection: ${key}:${value}`);
        }
        const collectionModel = this.Collection.getModel(collection.revision).value;
        if (!collectionModel) {
            throw new Error(`Unable to get collection model ${collection.revision}`);
        }
        return new IkeFetchableStatic(__1.IkeModel.Collection.summary(collectionModel));
    }
}
exports.IkeCollectionLoaderFromState = IkeCollectionLoaderFromState;
class IkeFetchableStatic {
    constructor(obj) {
        this.hasFetched = true;
        this.isFetching = false;
        this.lastFetch = Date.now();
        this.error = null;
        this.value = null;
        this.value = obj;
        this.promise = Promise.resolve(obj);
    }
    refetch() {
        return this.promise;
    }
    reset() {
        // ignore
    }
    fetch() {
        return this.promise;
    }
    init(value) {
        this.value = value;
        this.promise = Promise.resolve(value);
    }
}
exports.IkeFetchableStatic = IkeFetchableStatic;
//# sourceMappingURL=collection.loader.js.map